import { Injectable } from "@angular/core";
import { ITableColumn } from "src/app/models/tableColumns";
import { TableColumnsNames } from "src/app/models/tableColumns/tableColumnsNames.enum";

@Injectable({
    providedIn: "root",
})
export class ColumnsOrderService {
    getColumnsOrderFromLocalStorage(pageName: TableColumnsNames): ITableColumn[] | null {
        const columns = localStorage.getItem(`${pageName}_columns`);
        return columns ? JSON.parse(columns) : null;
    }

    saveColumnsOrderToLocalStorage(pageName: TableColumnsNames, columns: ITableColumn[]): void {
        localStorage.setItem(`${pageName}_columns`, JSON.stringify(columns));
    }
}
